export const API_BASE_URL =
  import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 'https://api.phenogenesis.com';

export const WS_BASE_URL =
  import.meta.env.VITE_WS_URL || import.meta.env.REACT_APP_WS_URL || 
  import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 
  'https://api.phenogenesis.com';

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    REGISTER_DRIVER: '/auth/register/driver',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    VERIFY_PHONE: '/auth/verify/phone',
    VERIFY_EMAIL: '/auth/verify/email',
    RESEND_VERIFICATION: '/auth/resend-verification',
    VERIFICATION_STATUS: '/auth/verification/status',
    DRIVER_DOCUMENTS: '/auth/driver/documents',
    UPLOAD_DOCUMENT: '/auth/driver/documents/upload',
    DRIVER_VERIFICATION_STATUS: '/auth/driver/verification/status',
  },
  USERS: {
    PROFILE: '/users/profile',
    UPDATE_PROFILE: '/users/profile',
    UPDATE_LOCATION: '/users/location',
  },
  RIDES: {
    CREATE: '/rides',
    LIST: '/rides',
    DETAIL: '/rides/:id',
    CANCEL: '/rides/:id/cancel',
    ESTIMATE: '/rides/estimate',
    ACCEPT: '/rides/:id/accept',
    START: '/rides/:id/start',
    COMPLETE: '/rides/:id/complete',
    ARRIVE: '/rides/:id/arrived',
    CURRENT: '/rides/passenger/active',
    HISTORY: '/rides/passenger/my-rides',
  },
  DRIVERS: {
    STATUS: '/drivers/status',
    LOCATION: '/drivers/location',
    VEHICLES: '/drivers/vehicles',
    EARNINGS: '/drivers/earnings',
    STATS: '/drivers/stats',
  },
  PAYMENTS: {
    METHODS: '/payments/methods',
    WALLET: '/payments/wallet/balance',
    WALLET_HISTORY: '/payments/wallet/history',
    ADD_MONEY: '/payments/wallet/funds',
    TRANSACTIONS: '/payments/history',
  },
  RATINGS: {
    CREATE: '/ratings',
    LIST: '/ratings',
  },
  CHAT: {
    CONVERSATIONS: '/chat/conversations',
    MESSAGES: '/chat/conversations/:id/messages',
    SEND: '/chat/conversations/:id/messages',
  },
  VEHICLE_TYPES: {
    LIST: '/vehicle-types',
  },
  SOS: {
    CREATE: '/sos',
    LIST: '/sos',
  },
  SERVICES: {
    LIST: '/services',
    SUGGESTED_DESTINATIONS: '/rides/passenger/suggested-destinations',
  },
};
